
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  emits: ['onChange'],
  props: {
    name: String as PropType<string>,
    value: String as PropType<string>,
    id: String as PropType<string>,
    type: {
      type: String as PropType<string>,
      default: 'text',
      validator: (value: string) => {
        return ['text', 'password', 'radio', 'checkbox', 'file'].includes(value)
      }
    }
  },
  methods: {
    handleOnInput (event: Event) {
      this.$emit('onChange', (event.target as HTMLInputElement).value)
    }
  }
})
